module.exports = __webpack_public_path__ + "assets/9d9ff8e4c56b56cc9fe597323fb93611.mp3";